var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("div", { staticClass: "flex justify-content-between mb-2" }, [
            _c("div", [
              _c("div", { staticClass: "custom-radio" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.track_type,
                        expression: "track_type",
                      },
                    ],
                    attrs: { type: "radio", value: "1" },
                    domProps: { checked: _vm._q(_vm.track_type, "1") },
                    on: {
                      change: function ($event) {
                        _vm.track_type = "1"
                      },
                    },
                  }),
                  _vm._v("\n              номера для заявок\n            "),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "custom-radio" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.track_type,
                        expression: "track_type",
                      },
                    ],
                    attrs: { type: "radio", value: "2" },
                    domProps: { checked: _vm._q(_vm.track_type, "2") },
                    on: {
                      change: function ($event) {
                        _vm.track_type = "2"
                      },
                    },
                  }),
                  _vm._v("\n              номера для накладных\n            "),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex justify-content-end flex_gap_5" },
              [
                !_vm.scanCommenced
                  ? _c("LoadingButton", {
                      attrs: {
                        title: "Запустить сканирование кодов",
                        className: "btn btn-outline-success",
                        loading: _vm.btnLoading,
                        color: _vm.$constants.SUCCESS_COLOR,
                        onClick: () => _vm.commenceScan(),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { type: "button" },
                    on: { click: _vm.openNewTrackModal },
                  },
                  [_vm._v("\n            Новый трэк номер\n          ")]
                ),
                _vm._v(" "),
                _c("LoadingButton", {
                  attrs: {
                    title: `Показать не отправленные (${_vm.totalOverdue})`,
                    className: "btn btn-outline-info",
                    loading: _vm.btnLoading,
                    color: _vm.$constants.LOADING_COLOR,
                    onClick: () => _vm.getRecords(1, true, "overdue"),
                  },
                }),
                _vm._v(" "),
                _c("LoadingButton", {
                  attrs: {
                    title: "Показать все",
                    className: "btn btn-outline-success",
                    loading: _vm.btnLoading,
                    color: _vm.$constants.LOADING_COLOR,
                    onClick: () => _vm.getRecords(1, true, "all"),
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          _vm.records && !_vm.loading
            ? [
                _c(
                  "table",
                  { staticClass: "table table-sm table-hover mt-0" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.records, function (r, i) {
                        return _c("tr", [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                i +
                                  1 +
                                  (_vm.paginator.current_page - 1) *
                                    _vm.paginator.per_page
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(r.data?.lastPoint?.icon))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "(" + _vm._s(r.id) + ") " + _vm._s(r.number)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(r.data?.lastPoint?.operationDateTime)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(r.data?.lastPoint?.operation)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              r.object_id
                                ? [
                                    r.object_type_id === 1
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-xs btn-outline-info mb-1 mr-1",
                                            on: {
                                              click: function ($event) {
                                                return _vm.orderToEdit(
                                                  r.order_id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-eye",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(r.object_id) +
                                        "\n              "
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.printDate(r.created_at))),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              _vm._l(r.comments, function (c) {
                                return _c("div", { staticClass: "comment" }, [
                                  _c("p", [_vm._v(_vm._s(c.text))]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "text-muted text-right" },
                                    [
                                      _vm._v(
                                        "(" +
                                          _vm._s(c.user_name) +
                                          ") " +
                                          _vm._s(_vm.printDate(c.date))
                                      ),
                                    ]
                                  ),
                                ])
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.saveComment.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    attrs: {
                                      type: "hidden",
                                      name: "record_id",
                                    },
                                    domProps: { value: r.id },
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    staticClass: "form-control",
                                    attrs: {
                                      name: "comment",
                                      required: "",
                                      type: "text",
                                      placeholder: "комментарий",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm._m(2, true),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex align-items-center flex_gap_5",
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      r.date ? _vm.printDate(r.date) : null
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                !_vm.commencedScan[r.id] && r.status !== 2
                                  ? _c("LoadingButton", {
                                      attrs: {
                                        title:
                                          '<i class="icon-fa icon-fa-refresh"/>',
                                        className: "btn btn-outline-success",
                                        loading: _vm.rescanLoading[r.id],
                                        color: _vm.$constants.LOADING_COLOR,
                                        onClick: () => _vm.commenceScan(r.id),
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              r.data?.events
                                ? _c(
                                    "v-popover",
                                    {
                                      attrs: {
                                        "auto-hide": true,
                                        popoverClass:
                                          "popover_trace_letter_body",
                                        placement: "left",
                                        trigger: "hover",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon-fa icon-fa-info info_fa",
                                      }),
                                      _vm._v(" "),
                                      _c("template", { slot: "popover" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "popover_post_track_trace",
                                          },
                                          _vm._l(
                                            [...r.data.events].reverse(),
                                            function (e) {
                                              return _c("div", [
                                                _c(
                                                  "p",
                                                  { staticClass: "text-muted" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        e.operationDateTime
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(e.operationAttribute)
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(e.operationPlaceName)
                                                  ),
                                                ]),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.paginator
            ? _c("paginate", {
                attrs: {
                  "page-count": _vm.paginator.last_page,
                  "page-range": 8,
                  "margin-pages": 2,
                  "click-handler": _vm.getRecords,
                  "prev-text": "&laquo",
                  "next-text": "&raquo",
                  "container-class": "pagination",
                  "prev-class": "page-item",
                  "prev-link-class": "page-link",
                  "page-class": "page-item",
                  "page-link-class": "page-link",
                  "next-class": "page-item",
                  "next-link-class": "page-link",
                  "active-class": "active green_btn",
                },
                model: {
                  value: _vm.paginator.current_page,
                  callback: function ($$v) {
                    _vm.$set(_vm.paginator, "current_page", $$v)
                  },
                  expression: "paginator.current_page",
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Трэк номера")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Трэк номер")]),
        _vm._v(" "),
        _c("th", [_vm._v("время статуса")]),
        _vm._v(" "),
        _c("th", [_vm._v("статус")]),
        _vm._v(" "),
        _c("th", [_vm._v("Заявка")]),
        _vm._v(" "),
        _c("th", [_vm._v("Создание номера")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Проверка")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-append" }, [
      _c(
        "button",
        { staticClass: "btn btn-outline-info", attrs: { type: "submit" } },
        [_c("i", { staticClass: "icon-fa icon-fa-save" })]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }